
















import Vue from "vue";
import ButtonAction from "../../components/ButtonAction.vue";

export interface UserRowViewModel {
  Id: string;
  Naam: string;
  Email: string;
  Active: boolean;
}

export default Vue.extend({
  components: {
    ButtonAction
  },
  props: {
    viewmodel: {
      type: Object as () => UserRowViewModel,
      required: true
    }
  },
  methods: {
    onSelectBtnClicked: function(id: string) {
      this.$router.push({ name: "users", params: { id } });
    }
  }
});
